import {Button, Input, InputNumber, Modal, Select} from "antd";


export default function UploadSubtitle({ props }) {

  function handleFileClick() {
    document.getElementById('subtitleUpload').click();
  }

  return <Modal
      visible={props.subtitleUploadVisibility}
      title="Upload Subtitle"
      onOk={props.UploadSubtitles}
      onCancel={props.toggleSubtitleUpload}
      footer={[
        <Button key="back" onClick={props.toggleSubtitleUpload}>
          Return
        </Button>,
        <Button
            type="primary"
            key="submit"
            className={"btn btn-success"}
            loading={props.loading}
            onClick={props.UploadSubtitles}
        >
          Submit
        </Button>,
      ]}
    >

    {
        (!props.subtitleFile && props.currentSubtitleName) && <>
          <div className={`w-100percent mb-1`}>Current Subtitle</div>
          <div className={`w-100percent mb-3`}>{props.currentSubtitleName}</div>
        </>
    }

    <div className={'w-100percent pt-1'}>
      <button onClick={handleFileClick}>
        Choose File
      </button>
      <span className='ml-2'>{props.subtitleFile?.name || 'No file chosen'}</span>
      <input type="file"
             id='subtitleUpload'
             name='filename'
             value=""
             hidden
             accept="text/vtt"
             onChange={(e) => {
               props.setSubtitleFile(e.target.files[0]);
             }}/>
    </div>
  </Modal>
}
